<x-y-graph [chartTitle]="'Live Video watched over time in minutes'" [showKey]="true" [chartId]="'streamingChart'" [stretchToFit]="true" 
    [graphPair]="graphPair">
    <div class="graph-date-controls" chart-controls>
        <div class="chart-component-header">Live Video</div>
        <date-selector (selectedDateChange)="onDateChange($event)" [selectedDate]="selectedDate" [startDate]="earliestSelectionDate" [endDate]="latestSelectionDate"/>
    </div>
</x-y-graph>
